import React from "react"

const EmployeesActiveIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="20" viewBox="0 0 22 20" fill="none">
            <path d="M13 6.99988H17" stroke="#21A6AA" stroke-width="1.5" stroke-linecap="round" />
            <path d="M13 10.4999H16" stroke="#21A6AA" stroke-width="1.5" stroke-linecap="round" />
            <rect x="1" y="0.999878" width="20" height="18" rx="5" stroke="#21A6AA" stroke-width="1.5" stroke-linejoin="round" />
            <path d="M4 13.9999C5.20831 11.4188 9.71218 11.249 11 13.9999" stroke="#21A6AA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M9.5 6.99988C9.5 8.10445 8.60457 8.99988 7.5 8.99988C6.39543 8.99988 5.5 8.10445 5.5 6.99988C5.5 5.89531 6.39543 4.99988 7.5 4.99988C8.60457 4.99988 9.5 5.89531 9.5 6.99988Z" stroke="#21A6AA" stroke-width="1.5" />
        </svg>
    )
}
export default EmployeesActiveIcon